export default __webpack_public_path__ + "static/media/arrowBack.cbf5e1a2.svg";